import React, { RefObject }  from "react";
import { RadialBarChart, RadialBar, Legend, PolarAngleAxis, Tooltip } from "recharts";
import { ChartDataModel } from "../Models/ChartDataModel";
import { DataHelper } from "../Helpers/DataHelper";
import { LoadingWidget } from "../Components/LoadingWidget";
import { ErrorWindow } from "../Components/ErrorWindow";

export class StudyProgress extends React.Component<
    {
        dataClient: DataHelper
    },
    {
        progressData: ChartDataModel[],
        isBusy: boolean
    }
> {

    //Data structure:
    // data = [
    //     {
    //       name: 'category',
    //       value: number,
    //       fill: '#color',
    //     }
    // ];

    style = {
        top: 0,
        left: 350,
        lineHeight: "24px"
    };

    errorWindow:  RefObject<ErrorWindow>;
    constructor(props: any) {
        super(props);
        this.errorWindow = React.createRef();
        this.state = {
            progressData: [],
            isBusy: false,
        }
    }

    componentDidMount(): void {
        this.setState({ isBusy: true })
        this.props.dataClient.CallDashboardService("GetStudyProgress", {}, {}, (result: string) => {
            let studyProgress = JSON.parse(result);
            const colors = ['#F5812E', '#45BCB4', '#9FB6E8', '#91837A', '#F2C94C', '#7FC29B', '#E6E0D8', '#D99A6C', '#B7C9E2', '#D6D96F', '#E3B6CC', '#9FA1A4']
;
            for (let index = 0; index < studyProgress.length; index++) {
                const element = studyProgress[index];
                element.fill = colors[index % colors.length];
            }
            this.setState({ progressData: studyProgress, isBusy: false })
        }, (stautus:number, errorMessage:string)=>{
            (this.errorWindow.current as ErrorWindow).show(stautus, errorMessage)}, "GET", false)}

    render() {

        return (
            <>
            <ErrorWindow ref={this.errorWindow}/>
            <h3>Study progress</h3>
            <div className="chartHolder">
                
                <RadialBarChart
                    width={580}
                    height={340}
                    cx={170}
                    cy={170}
                    innerRadius={20}
                    outerRadius={160}
                    barSize={20}
                    data={this.state.progressData}
                    >

                    <PolarAngleAxis
                        type="number"
                        domain={[0, 100]}
                        dataKey={"value1"}
                        angleAxisId={0}
                        tick={false}
                    />
                    <RadialBar
                        
                        background={{ fill: "#ececec" }}
                        label={{ position: "insideStart", fill: "#4A4A4A", formatter: (value1: number) => `${value1.toFixed(0)}%`}}
                        dataKey="value1"
                        angleAxisId={0}
                    />
                    <Tooltip
                        formatter={(value: number) => [value, "Procedures"]}
                        labelFormatter={() => ""}
                    />
                    <Legend
                        iconSize={10}
                        width={220}
                        height={280}
                        layout="vertical"
                        wrapperStyle={this.style}
                        align={"left"}
                    />
                </RadialBarChart>
                <LoadingWidget visible={this.state.isBusy} zIndexLayer={0}></LoadingWidget>
            </div>
            </>
        );
    }
}
